
import axios from 'axios'
import { useEffect } from 'react'

//synchronous action creator


const fetchVideosData= (videos) => ({


    type: 'FETCH_VIDEOS',
    payload: {videos}
})


const updateVideosData = (videos) => ({

    type: 'UPDATE_VIDEOS',
    payload: {videos}
})

export const editPost = (videos) => (dispatch) => {
    dispatch(updateVideosData(videos));
  };

export const fetchVideos =  () => {
    return async dispatch => {
        try {
            //let posts = await axios.get('https://mychannel7tv.co.uk/wp-json/wp/v2/show')
            let posts  = await axios.get('https://nastaanaisie.pythonanywhere.com/api/videos/')
            dispatch(fetchVideosData(posts.data)) //store first five posts
           // dispatch(loading(true))

           console.log("videos", posts)
          
        }
        catch(e){
            console.log(e)
        }
    }
}

